import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useQuery } from '@apollo/client';
import classNames from 'classnames/bind';

import Modal from '@mui/material/Modal';
import DialogContent from '@mui/material/DialogContent';

import * as Q from '../../../constants/graphqlQueries';
import { authenticationDenied } from '../../../constants/accessDeniedMessages';
import ModalDetail from '../../ModalDetail/ModalDetail';

import styles from './AspectStatus.module.css';

const cx = classNames.bind(styles);

const AlarmsStatus = ({ StatusResponse }) => {
  const [open, setOpen] = useState(false);

  const { loading, error, data } = useQuery(Q.ASPECT_ALARMS_STATUS_QUERY, {
    pollInterval: 15 * 60 * 1000,
  });

  if (loading) return <p>Loading...</p>;
  if (error || !data) {
    if (!open) setOpen(true);
  }

  if (open) {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
      >
        <DialogContent className='dialog delete-rule'>
          <ModalDetail className='modal delete-rule'
            modalOptions={authenticationDenied}
          />
        </DialogContent>
      </Modal>
    )
  };

  // Add null check before accessing data
  const status = data?.aspectHealthAlarmsWebService || 'Unavailable';

  const classNameStatus = cx({
    status: true,
    error: status !== StatusResponse,
    ok: status === StatusResponse,
  });

  const classNameLabel = cx({
    aspectHealthOptions: true,
  });

  return (
    <div className={classNameLabel}>
      Alarms:
      <div className={classNameStatus}>{status}</div>
    </div>
  );
};

AlarmsStatus.propTypes = {
  StatusResponse: PropTypes.string.isRequired,
};

export default AlarmsStatus;
